<template>
  <div class="info-dialog" v-if="visible">
    <div class="dialog-content">
      <i class="icon icon-close" @click="closeDialog"></i>
      <div class="info-title">
        <div class="each-tit">留下你的联系方式</div>
        <div class="each-tit">让我们找到你</div>
      </div>
      <div class="info-detail">
        <div class="detail-tit">电话号码</div>
        <input class="detail-inp" type="number" v-model="form.phone" :readonly="isEffective ? false : 'readonly'" />
      </div>
      <div class="info-detail">
        <div class="detail-tit">你最近的烦恼</div>
        <textarea class="detail-inp" rows="4" v-model="form.order_content" :readonly="isEffective ? false : 'readonly'"/>
      </div>
      <div class="info-tips">
        <p><span class="spl-font">*</span>名单公布时间：{{publishTime}}</p>
        <p><span class="spl-font">*</span>本次直播时间：请关注官博</p>
      </div>
      <div class="info-btns">
        <button v-if="isEffective" @click="submitAppoint">提交</button>
        <button class="btn-invaild" v-else>已预约</button>
      </div>
    </div>
    <toast ref="toast" />
  </div>
</template>
<script>
import _ from 'lodash';
import * as Apis from '@/apis'
import DialogMixins from '@/mixins/DialogMixins'
import { PUBLISH_TIME, RESERVE_NUM } from '../constans'

export default {
  mixins: [DialogMixins],
  props: ['originInfo'],
  data() {
    return {
      publishTime: PUBLISH_TIME,
      form: {
        phone: '',
        order_content: '',
        order_type: RESERVE_NUM,
      }
    }
  },
  watch: {
    originInfo(val) {
      if (val) {
        this.form = _.assign(this.form, val);
      }
    }
  },
  computed: {
    isEffective() {
      return this.originInfo === null;
    }
  },
  methods: {
    checkForm() {
      const {
        form: { phone, order_content }
      } = this;
      if (!phone) return '请填写电话号码';
      if (!order_content) return '请填写你最近的烦恼';
    },
    async submitAppoint() {
      const msg = this.checkForm();
      if (msg) {
        return this.$emit('showMessage', msg);
      }
      const { uuid } = this.dataStore.getInfo();
      try {
        await Apis.saveLive({uuid, ...this.form});
        this.closeDialog();
        this.$emit('showMessage', '已预约');
      } catch (error) {
        this.$emit('showMessage', error);
      }
    },
  },
}
</script>
<style lang="scss">
@import "~@/assets/mixins.scss";

.info-dialog{
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(11, 11, 11, 0.52);
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  .dialog-content{
    position: relative;
    @include px2vw(width, 597);
    @include px2vw(height, 656);
    @include px2vw(padding-top, 47);
    @include px2vw(padding-bottom, 22);
    @include px2vw(padding-left, 50);
    @include px2vw(padding-right, 50);
    @include px2vw(font-size, 24);
    background-image: url("~@/assets/img/appoint-dialog.png");
    background-size: 100% 100%;

    .info{
      &-title{
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;

        .each-tit{
          @include px2vw(height, 44);
          @include px2vw(line-height, 44);
          @include px2vw(margin-bottom, 10);
          @include px2vw(padding-left, 25);
          @include px2vw(padding-right, 25);
          text-align: center;
          color: #fff;
          background-color: #668DF7;
        }
      }

      &-detail{
        .detail-tit{
          @include px2vw(margin-top, 29);
          @include px2vw(margin-bottom, 16);
          @include px2vw(font-size, 26);
          text-align: center;
        }

        .detail-inp{
          display: block;
          width: 100%;
          resize: none;
          @include px2vw(padding, 10);
          @include px2vw(border-width, 2);
          border-style: solid;
          border-color: #979797;
        }
      }

      &-tips{
        @include px2vw(margin-top, 20);
        @include px2vw(font-size, 24);
        line-height: 1.5;

        .spl-font{
          color: #eb4a41;
        }
      }

      &-btns{
        @include px2vw(margin-top, 15);
        text-align: center;
        
        button{
          @include px2vw(width, 204);
          @include px2vw(height, 50);
          @include px2vw(font-size, 26);
          @include px2vw(border-radius, 9999);
          color: #fff;
          background-color: #FF5F00;
          border: none;

          &.btn-invaild{
            @include px2vw(font-size, 32);
            color: #FF3434;
            background-color: transparent;
          }
        }
      }
    }
  }
}
.icon{
  &-close{
    position: absolute;
    z-index: 100;
    @include px2vw(right, 20);
    @include px2vw(top, 25);
  }
}
</style>